import { render, staticRenderFns } from "./BrandGrid.vue?vue&type=template&id=c7433122&scoped=true&"
import script from "./BrandGrid.vue?vue&type=script&lang=js&"
export * from "./BrandGrid.vue?vue&type=script&lang=js&"
import style0 from "./BrandGrid.vue?vue&type=style&index=0&id=c7433122&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7433122",
  null
  
)

export default component.exports